import * as FlatModels from '@medsurf/flat-models';
import * as EntityBaseActions from '../base/entity.base.actions';

// <editor-fold desc="Action Types">

/**
 * Action Types
 */
export enum ActionTypes {
  /**
   * Store
   */
  GetEntitySuccess = '[STORE | ENTITY | STAIN] Get Entity Success',
  GetEntitiesSuccess = '[STORE | ENTITY | STAIN] Get Entities Success',
  ModifyEntitySuccess = '[STORE | ENTITY | STAIN] Modify Entity Success',
  ModifyEntitiesSuccess = '[STORE | ENTITY | STAIN] Modify Entities Success',
  AddEntity = '[STORE | ENTITY | STAIN] Add Entity',
  UpdateEntity = '[STORE | ENTITY | STAIN] Update Entity',
  RemoveEntity = '[STORE | ENTITY | STAIN] Remove Entity',
  /**
   * Request
   */
}

// </editor-fold>

// <editor-fold desc="Models">

// </editor-fold>

// <editor-fold desc="Store">

/**
 * Get Entity Success
 */
export class GetEntitySuccess extends EntityBaseActions.GetEntitySuccess {
  public static readonly type = ActionTypes.GetEntitySuccess;
}

/**
 * Get Entities Success
 */
export class GetEntitiesSuccess extends EntityBaseActions.GetEntitiesSuccess {
  public static readonly type = ActionTypes.GetEntitiesSuccess;
}

/**
 * Modify Entity Success
 */
export class ModifyEntitySuccess extends EntityBaseActions.ModifyEntitySuccess {
  public static readonly type = ActionTypes.ModifyEntitySuccess;
}

/**
 * Modify Entities Success
 */
export class ModifyEntitiesSuccess extends EntityBaseActions.ModifyEntitiesSuccess {
  public static readonly type = ActionTypes.ModifyEntitiesSuccess;
}

/**
 * Add Entity
 */
export class AddEntity extends EntityBaseActions.AddEntity<FlatModels.StainEntityModels.Stain> {
  public static readonly type = ActionTypes.AddEntity;
}

/**
 * Update Entity
 */
export class UpdateEntity extends EntityBaseActions.UpdateEntity<FlatModels.StainEntityModels.Stain> {
  public static readonly type = ActionTypes.UpdateEntity;
}

/**
 * Remove Entity
 */
export class RemoveEntity extends EntityBaseActions.RemoveEntity<FlatModels.StainEntityModels.Stain> {
  public static readonly type = ActionTypes.RemoveEntity;
}

// </editor-fold>

// <editor-fold desc="Request">

// </editor-fold>